import {useCallback, useState} from "react";

export default function useJson<T>(initial: T = {} as T): [T, (obj: Partial<T>) => void] {
    const [state, setState] = useState<T>(initial);
    const setObject = useCallback((obj: T) => {
        setState(prev => ({...prev, ...obj}));
    }, [])

    return [state, setObject];
}